import React, { useState } from 'react'

import dynamic from 'next/dynamic'

import Button from 'components/Button'
import { FixedImage } from 'components/NextImage'
import Typography from 'components/Typography'

import classes from './DialogInternational.module.scss'

const noop = () => {}

const Dialog = dynamic(() => import('./components/Dialog'))

/** @type {import("./types").default} */
const DialogInternational = ({ onCountryClick = noop }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDialog = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Button
        className={classes.countrySelectButton}
        color="inherit"
        onClick={toggleDialog}
        variant="outlined"
        data-testid="dialogInternational-button"
      >
        <FixedImage
          className={classes.selectedFlag}
          height={20}
          width={30}
          src="/img/country-flags/us.png"
          alt="United States (English)"
          loading="lazy"
        />
        <Typography variant="button-md">United States (English)</Typography>
      </Button>
      {isOpen && <Dialog isOpen={isOpen} onCountryClick={onCountryClick} toggleDialog={toggleDialog} />}
    </>
  )
}

export default DialogInternational
